module.exports = "<span [innerHTML]=\"data\"></span>";